import React, {useContext, useEffect} from 'react'
import {VenueContext} from "../Context"
import Venue from "./Venue.js"
import {Images} from "./images"
import MapContainer from "./MapContainer"
import Loading from "./Loading";
function VenueListing(props) {
    const { venues, isLoading } = useContext(VenueContext);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    let createVenues = venues.map((venue, index) => (
        <Venue
            img={Images[index]}
            name={venue.name}
            key={venue.id}
            slug={venue.name}
            price={Math.floor(Math.random() * 400)}
            rating={Math.floor(Math.random() * 100)}
            capacity={Math.ceil(Math.random() * 900)}
        />
    ));

    return (
        <div className="row">
        <div className="col-md-6">
        {isLoading ? <Loading />: <MapContainer /> }
        </div>
            <div className="col-md-6" style={{ background: "rgb(246, 246, 246)"}}>
                <h1 className="venue-listing-title" style={{paddingTop:"2rem"}}>Showing {venues.length} Premium Performance Spaces </h1>
                <div className="venue-container container" style={{ overflowY: "scroll", height: "100vh", padding: "1rem",}}>
                    <div className="row" style={{height: "100vh"}}>
                        {isLoading ? <Loading /> : createVenues}
                    </div>
         </div>
        </div>
        </div>
    )
}
export default VenueListing
